import {http} from 'lib/httpAxios'

export default {
  retrieveAppointmentDocumentList (accountCode) {
    return http.get(`/appointments/reception/${accountCode}/files`)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  },
  uploadApointmentFile (parameters) {
    return http.post(`/appointments/reception/${parameters.accountCode}`, parameters.file)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  },
  saveApointmentFile (parameters) {
    return http.post(`/appointments/reception/${parameters.accountCode}/save`, parameters.data)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  }
}



// WEBPACK FOOTER //
// ./src/vuex/api/services/reception.js